import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { QUERY_KEYS } from 'settings/config';
import { useApiReady } from './use-api-ready';

/** Get the selected buyer org */
export function useBookingHistory(bookingId: string, historyId: string) {
  const enabled = useApiReady();
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);

  return useQuery(
    [QUERY_KEYS.bookingHistory, bookingId, historyId],
    () =>
      new ApiClient().BookingHistoryApi.orgBookingHistoryRetrieve({
        bookingId: bookingId || '',
        buyerOrgId: activeBuyerOrgId || '',
        historyId: historyId || '',
      }),
    {
      select: (data) => data.data,
      enabled: enabled && !!activeBuyerOrgId && !!bookingId && !!historyId,
    }
  );
}
